import { installationClient } from './api-grpc';
import { Installation, SiphonDiameter, SiphonMaterial, SiphonType } from '../gen/proto/api/gateway/v1/installation_pb';
import type { JsonObject } from '@bufbuild/protobuf';

export const installationApi = {
  async getByUuid(uuid: string): Promise<Installation> {
    const response = await installationClient.getInstallationByUuid({ uuid });
    if (!response.installation) {
      throw new Error('No installation returned for uuid: ' + uuid);
    }
    return response.installation;
  },

  async getByUuids(uuids: string[]): Promise<Installation[]> {
    const results = await Promise.all(uuids.map((uuid) => this.getByUuid(uuid)));
    return results;
  },

  async create(
    name: string,
    erpId: string,
    siphonType: SiphonType,
    siphonMaterial: SiphonMaterial,
    siphonDiameter: SiphonDiameter,
    siphonEffluent: string | undefined,
    siphonLimit: number,
    locationUuid: string,
    comment?: string,
  ): Promise<Installation> {
    const response = await installationClient.createInstallation({
      name,
      erpId,
      siphonType,
      siphonMaterial,
      siphonDiameterMm: siphonDiameter,
      siphonEffluentSiphonUuid: siphonEffluent,
      siphonCollapseLimitPercentage: siphonLimit,
      locationUuid,
      comment,
    });
    if (!response.installation) {
      throw new Error('No installation returned after create');
    }
    return response.installation;
  },

  async update(
    uuid: string,
    name: string,
    erpId: string,
    locationUuid: string,
    siphonType: SiphonType,
    siphonMaterial: SiphonMaterial,
    siphonDiameter: SiphonDiameter,
    siphonEffluent: string | undefined,
    siphonLimit: number,
    otherInfo?: JsonObject,
    comment?: string,
  ): Promise<Installation> {
    const response = await installationClient.updateInstallation({
      uuid,
      name,
      erpId,
      locationUuid,
      siphonType,
      siphonMaterial,
      siphonDiameterMm: siphonDiameter,
      siphonEffluentSiphonUuid: siphonEffluent,
      siphonCollapseLimitPercentage: siphonLimit,
      otherInfo,
      comment,
    });
    if (!response.installation) {
      throw new Error('No installation returned after update');
    }
    return response.installation;
  },

  async getInstallationByLocationUuid(uuid: string): Promise<Installation[]> {
    const resposnse = await installationClient.getAllInstallationsByLocationUuid({
      locationUuid: uuid,
    });
    if (resposnse === null) {
      throw new Error('Error fetching installations');
    }
    return resposnse.installations;
  },

  async deleteInstallation(uuid: string): Promise<void> {
    await installationClient.deleteInstallation({ uuid: uuid });
  },
};
